import { callApi } from 'helper/promises';
import Usefetchdata from 'hooks/usefetchdata';
import { useCallback, useMemo } from 'react';

/**
 * The signed-in user of the CRM pages, and `call(method, payload)` that runs a
 * method of server/crm/crmApi as a promise. `ready` waits for the user.
 */
const useCrmContext = () => {
  const { userData } = Usefetchdata();
  const { _id: id, firstname, lastname } = userData ?? {};
  const me = useMemo(
    () => (id ? { id, firstname: firstname ?? '', lastname: lastname ?? '' } : null),
    [id, firstname, lastname],
  );
  const call = useCallback((method, payload = {}) => callApi(method, payload), []);
  return { me, ready: Boolean(me), call };
};

export default useCrmContext;
